var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 121.163,
    height: 121.163,
    viewBox: "0 0 121.163 121.163",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}.b{fill:#a4c2f7;}.c{fill:#e8edfc;}.d{fill:#cad9fc;}.e{fill:#efd2ff;}.f{fill:#fff;}.g{fill:#264ecc;}.h{fill:#7821a0;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: -0.672,
    y1: -3.759,
    x2: -0.669,
    y2: -3.765,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d3dff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.172,
    stopColor: "#d3dff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#d3dff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#dae2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.201,
    stopColor: "#ebeaf2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.201,
    stopColor: "#f6eff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202,
    stopColor: "#fdf2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.205,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.252,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#d3dff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.397,
    stopColor: "#d3dff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#d3dff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#dae2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421,
    stopColor: "#ebeaf2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421,
    stopColor: "#f6eff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.422,
    stopColor: "#fdf2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f8f0f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#e7e8f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#dce3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#d5e0f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#d3dff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.706,
    stopColor: "#d3dff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#d3dff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851,
    stopColor: "#d3dff2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-32.626 -908.483)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.626 908.483)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M132.21,982.5v15.691H51.434V960.062a28.379,28.379,0,0,0,9.895,1.777H85.764a2.019,2.019,0,0,0,2.02-2.019v-8.077H95.86v4.241A27.783,27.783,0,0,0,123,984.052,26.751,26.751,0,0,0,132.21,982.5Z",
    transform: "translate(-31.24 -905.296)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M121.025,981.758v14.319h6.058V980.387A26.407,26.407,0,0,1,121.025,981.758Z",
    transform: "translate(-26.113 -903.186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M74.34,1009.136H42.03L52.127,995H132.9l10.1,14.135H74.34Z",
    transform: "translate(-31.933 -902.109)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M127.083,995h-6.058l10.1,14.135h6.058Z",
    transform: "translate(-26.113 -902.109)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M74.34,1008.166H42.03v6.059a6.058,6.058,0,0,0,6.059,6.058h88.853a6.058,6.058,0,0,0,6.058-6.058v-6.059Z",
    transform: "translate(-31.933 -901.139)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M130.845,1008.166v6.059a6.058,6.058,0,0,1-6.059,6.058h6.059a6.058,6.058,0,0,0,6.058-6.058v-6.059Z",
    transform: "translate(-25.836 -901.139)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M90.3,1012.621h14.135l4.039-4.039-2.02-6.058H74.143l-2.02,6.058,4.039,4.039Z",
    transform: "translate(-29.716 -901.555)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M89.03,938.433v24.435a2.019,2.019,0,0,1-2.02,2.019H62.576a28.379,28.379,0,0,1-9.895-1.777,27.134,27.134,0,0,1,9.209-52.746,26.665,26.665,0,0,1,17.629,6.825,28.472,28.472,0,0,1,9.512,21.244Z",
    transform: "translate(-32.487 -908.345)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M77.858,917.189a26.665,26.665,0,0,0-17.629-6.825,27.431,27.431,0,0,0-3.185.188A26.745,26.745,0,0,1,71.8,917.189a28.476,28.476,0,0,1,9.512,21.244v24.435a2.019,2.019,0,0,1-2.02,2.02H85.35a2.019,2.019,0,0,0,2.02-2.02V938.433A28.472,28.472,0,0,0,77.858,917.189Z",
    transform: "translate(-30.827 -908.344)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M147.335,958.193a27.276,27.276,0,0,1-18.174,25.828,26.748,26.748,0,0,1-9.208,1.555,27.783,27.783,0,0,1-27.141-28.069V933.073a2.019,2.019,0,0,1,2.02-2.02h24.435a27.782,27.782,0,0,1,28.069,27.14Z",
    transform: "translate(-28.192 -906.82)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M117.867,931.053h-6.058a27.783,27.783,0,0,1,28.069,27.14A27.276,27.276,0,0,1,121.7,984.022a26.56,26.56,0,0,1-6.084,1.375,26.991,26.991,0,0,0,12.142-1.375,27.276,27.276,0,0,0,18.174-25.828A27.782,27.782,0,0,0,117.867,931.053Z",
    transform: "translate(-26.792 -906.82)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 13.126,
    cy: 13.126,
    r: 13.126,
    transform: "translate(16.156 14.136)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 13.126,
    cy: 13.126,
    r: 13.126,
    transform: "translate(78.756 36.349)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M118.411,942.338a13.094,13.094,0,0,0-3.029.365,13.112,13.112,0,0,1,0,25.521,13.126,13.126,0,1,0,3.029-25.886Z",
    transform: "translate(-26.529 -905.989)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M136.546,974.956v2.161a27.569,27.569,0,0,1-8.077,4.523,26.738,26.738,0,0,1-26.252-4.766v-1.9a12.278,12.278,0,0,1,8.078-11.591,13.148,13.148,0,0,0,18.215-.02A12.247,12.247,0,0,1,136.546,974.956Z",
    transform: "translate(-27.499 -904.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M127.537,963.365a13.357,13.357,0,0,1-2.625,1.943,12.318,12.318,0,0,1,4.6,9.648v2.161a27.569,27.569,0,0,1-8.077,4.523,26.441,26.441,0,0,1-6.02,1.367,26.354,26.354,0,0,0,12.078-1.367,27.569,27.569,0,0,0,8.077-4.523v-2.161a12.247,12.247,0,0,0-8.036-11.591Z",
    transform: "translate(-26.526 -904.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M78.241,954.289v8.219H61.883a28.565,28.565,0,0,1-17.972-6.381v-1.859a12.293,12.293,0,0,1,8.038-11.611,13.126,13.126,0,0,0,18.215.04,12.257,12.257,0,0,1,8.077,11.591Z",
    transform: "translate(-31.794 -905.965)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M42.584,1015.371v6.059a6.058,6.058,0,0,0,6.059,6.058H54.7a6.058,6.058,0,0,1-6.058-6.058v-6.059l10.1-14.135V963.11a27.9,27.9,0,0,1-8.077-4.619c-19.065-15.472-9.312-45.518,14.1-47.95a26.575,26.575,0,0,0-2.877-.177c-25.687-.105-37.2,31.971-17.286,48.127a27.9,27.9,0,0,0,8.077,4.619v38.126Z",
    transform: "translate(-32.487 -908.344)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M49.554,979.954h4.038V996.11H49.554Z",
    transform: "translate(-31.379 -903.218)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M51.573,983.082a2.019,2.019,0,0,0,2.02-2.02V966.927a2.019,2.019,0,0,0-4.038,0v14.136A2.019,2.019,0,0,0,51.573,983.082Z",
    transform: "translate(-31.379 -904.326)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M51.611,989.635a2.019,2.019,0,1,1-.02-4.038h.02a2.019,2.019,0,1,1,0,4.038Z",
    transform: "translate(-31.376 -902.802)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M133.041,985.6a2.019,2.019,0,0,0-2.02,2.018v6.059H52.265a2.162,2.162,0,0,0-1.644.846c-10.674,15.107-10.391,14.1-10.473,15.308v6.059a8.078,8.078,0,0,0,8.078,8.077H137.08a8.077,8.077,0,0,0,8.077-8.077v-6.059c-.2-1.651-.107-.322-10.1-14.783v-7.43A2.019,2.019,0,0,0,133.041,985.6Zm8.077,30.29a4.039,4.039,0,0,1-4.038,4.039H48.227a4.039,4.039,0,0,1-4.039-4.039v-4.039H73.643l3.446,3.448a2.018,2.018,0,0,0,1.428.592h28.271a2.017,2.017,0,0,0,1.428-.592l3.448-3.448h29.454Zm-48.464-4.039h-13.3l-2.565-2.564,1.165-3.494h29.4l1.165,3.494-2.564,2.564Zm19.63-4.038-1.559-4.677a2.019,2.019,0,0,0-1.917-1.382H76.5a2.019,2.019,0,0,0-1.917,1.382l-1.559,4.677H46.093l7.213-10.1H132l7.214,10.1Z",
    transform: "translate(-32.071 -902.802)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M81,915.817a28.836,28.836,0,0,0-18.964-7.334h-.129a29.269,29.269,0,0,0-29.281,29.41,29.748,29.748,0,0,0,30.089,29.152H87.149a4.039,4.039,0,0,0,4.039-4.039V938.572A30.469,30.469,0,0,0,81,915.817ZM56.859,962.338v-3.37a2.02,2.02,0,1,0-4.039,0V961.1a26.175,26.175,0,0,1-6.058-3.433v-.88a10.326,10.326,0,0,1,5.672-9.242,15.079,15.079,0,0,0,18.9.032,10.269,10.269,0,0,1,5.715,9.23v6.2H70.995v-4.038a2.02,2.02,0,1,0-4.039,0v4.038H62.715A26.829,26.829,0,0,1,56.859,962.338Zm5.048-15.487a11.107,11.107,0,1,1,11.107-11.107A11.107,11.107,0,0,1,61.907,946.852Zm25.242,16.155H81.092v-6.2A14.338,14.338,0,0,0,74.2,944.553a15.145,15.145,0,1,0-24.614-.034,14.353,14.353,0,0,0-6.6,9.672,24.636,24.636,0,0,1-6.321-16.313,25.241,25.241,0,0,1,25.242-25.355h.105a24.778,24.778,0,0,1,16.3,6.314,26.417,26.417,0,0,1,8.838,19.735Z",
    transform: "translate(-32.626 -908.483)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M119.4,929.172H94.97a4.039,4.039,0,0,0-4.038,4.039v24.435a30.029,30.029,0,0,0,21.4,28.949c.039.016.083.018.121.032a28.351,28.351,0,0,0,7.634,1.107h.12a29.268,29.268,0,0,0,29.281-29.4A29.752,29.752,0,0,0,119.4,929.172Zm.7,54.523a24.354,24.354,0,0,1-4.942-.529v-3.509a2.019,2.019,0,1,0-4.038,0v2.259a24.993,24.993,0,0,1-6.059-3.487V977.5a10.27,10.27,0,0,1,5.715-9.23,15.079,15.079,0,0,0,18.9-.032,10.326,10.326,0,0,1,5.673,9.242v1.146A24.95,24.95,0,0,1,129.3,982v-2.339a2.02,2.02,0,1,0-4.039,0v3.533a25.554,25.554,0,0,1-5.048.5Zm.105-16.154a11.107,11.107,0,1,1,11.108-11.107,11.107,11.107,0,0,1-11.108,11.107Zm18.981,7.53a14.368,14.368,0,0,0-6.662-9.863,15.145,15.145,0,1,0-24.618.034,14.3,14.3,0,0,0-6.613,9.59,26.39,26.39,0,0,1-6.329-17.186V933.211H119.4a25.705,25.705,0,0,1,26.05,25.137,25.033,25.033,0,0,1-6.261,16.723Z",
    transform: "translate(-28.33 -906.959)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M95.228,976.583a30.253,30.253,0,0,1-4.372.3A32,32,0,0,1,68,967.394a2.02,2.02,0,1,0-2.866,2.847,36,36,0,0,0,25.725,10.682,34.363,34.363,0,0,0,4.959-.345,2.02,2.02,0,0,0-.587-4Z",
    transform: "translate(-30.274 -904.187)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M113.805,926.38a2.019,2.019,0,0,0,1.431-3.432,36,36,0,0,0-25.724-10.7,35.033,35.033,0,0,0-5,.343,2.02,2.02,0,1,0,.579,4,30.842,30.842,0,0,1,4.417-.3,31.993,31.993,0,0,1,22.86,9.5A2.017,2.017,0,0,0,113.805,926.38Z",
    transform: "translate(-28.93 -908.206)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRed);
export default __webpack_public_path__ + "static/media/red.00b88e918ba9e27dbb9334e88e258ae8.svg";
export { ForwardRef as ReactComponent };